import { useConfigurationQuery } from 'App/actions/api/configuration';
import { deriveConfiguration } from 'App/domain/configuration';

export const useConfiguration = () => {
  const { data } = useConfigurationQuery();
  return deriveConfiguration(data);
};
